<template>
    <span class="cs-menu-center-double">
        <CSMenuLeft :data="data" />
    </span>
</template>

<script>
    export default {
        name: "CSMenuCenterDouble",
        components: {
            CSMenuLeft: () => import('./CSMenuJustify.vue')
        },
        props: {
            data: {
                type: Object,
            default: () => {},
            }
        },
        mounted(){}
    };
</script>

<style lang="scss" scoped>
  @import "../../styles/main.scss";
    
    ::v-deep {
        .navbar-collapse {
            justify-content: unset !important;
            position: relative;

            .cs-logo.desktop {
                position: absolute;
                z-index: 3;
                left: 0;
                right: 0;
                margin: auto;
                width: 150px;
            }

            .cs-nav-primary-links {
                margin-left: 0px !important;
            }
        }
    }
</style>